module.exports = __webpack_public_path__ + "static/fire_giant-5e395eb4838f2d5129bfe46a571e889b.jpeg";